import React from "react";
import { useGoogleMapLoader } from "src/hooks/map";
import { useBreakpointIsLowerOrEqual } from "src/hooks/responsive";
import AddressSearch, { AddressSearchProps } from "./AddressSearch";
import AddressDropdown from "./AddressDropdown";
import MobileAddressDropdown from "./MobileAddressDropdown";

const AddressSearchWithMap: React.FC<AddressSearchProps> = ({ variant, ...restProps }) => {
  const { isLoaded } = useGoogleMapLoader();
  const isMobile = useBreakpointIsLowerOrEqual("md");

  if (!isLoaded) {
    return null;
  }

  if (variant === "dropdown") {
    // Use mobile version for small screens (tablets and below)
    if (isMobile) {
      return <MobileAddressDropdown variant={variant} {...restProps} />;
    }
    return <AddressDropdown variant={variant} {...restProps} />;
  }

  return <AddressSearch variant={variant} {...restProps} />;
};

export default AddressSearchWithMap;
export { MobileAddressDropdown, AddressDropdown, AddressSearch };
